import { Resource } from "i18next";



import snaiVFr from 'locales/fr/snaiV.json';
import snaiVEn from 'locales/en/snaiV.json';

export const resource: Resource = {
    fr: {
      snaiV: snaiVFr,
    },
    en: {
      snaiV: snaiVEn,
    }
  }